import { Link } from 'gatsby'

interface LinkButtonProps {
  label?: string
  url?: string
  mobile?: boolean
  target?: string
  rel?: string
  onClick?: VoidFunction
  big?: boolean
  prefetch?: boolean
  alt?: boolean
}

const LinkButton = ({
  label = 'Try it out',
  url = '/',
  mobile = false,
  target = '_self',
  rel,
  onClick,
  big = false,
  prefetch = false,
  alt = false,
}: LinkButtonProps) => {
  return (
    <div className="linkbutton-container">
      {prefetch ? (
        <Link
          to={url}
          target={target}
          rel={rel}
          onClick={onClick}
          className={`button linkbutton ${mobile ? 'mobile' : ''} ${
            alt ? 'alt' : ''
          } ${big ? 'big' : ''}`}
        >
          {label}
        </Link>
      ) : (
        <a
          href={url}
          target={target}
          rel={rel}
          onClick={onClick}
          className={`button linkbutton ${mobile ? 'mobile' : ''} ${
            alt ? 'alt' : ''
          } ${big ? 'big' : ''}`}
        >
          {label}
        </a>
      )}
    </div>
  )
}

export default LinkButton
